import { render, staticRenderFns } from "./editTrackCover.vue?vue&type=template&id=6c300db3&scoped=true&"
import script from "./editTrackCover.vue?vue&type=script&lang=js&"
export * from "./editTrackCover.vue?vue&type=script&lang=js&"
import style0 from "./editTrackCover.vue?vue&type=style&index=0&id=6c300db3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c300db3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VImg,VProgressCircular})
